export default "__VITE_ASSET__Clzq_sL1__"